import React from 'react'
import styled from 'styled-components'

import { Text, withTooltip } from '@procsea/design-system'

import { IconProps } from './icons.types'

const StyledNew = styled(Text)`
  display: inline-flex;
  background-color: ${props => props.theme.colors.primary.base};
  padding: 0.1rem 0.4rem;
  border-radius: 7px;
}
`

const NewIcon = ({ 'data-e2e': dataE2e = 'has-new' }: IconProps) => (
  <StyledNew data-e2e={dataE2e} size="xsmall" variant="white">
    NEW
  </StyledNew>
)

export default withTooltip(NewIcon)
